<template>
  <div>
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="mr-2 header-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
                fill="#353535"
              />
            </svg>
          </i>
          <h1 class="xxl">
            {{ resource["subscription.HeaderText"] }}
          </h1>
        </div>
      </div>
    </div>
    <div class="page-view">
      <div class="container my-account p-0">
        <div class="c-column-01 flex-row justify-content-between">
          <div class="c-container-02">
            <div class="c-item-01">
              {{ resource["subscription.accountText"] }}
            </div>
            <div class="c-item-02">
              {{
                currentUser.companyName ||
                resource["subscriptionPageNoAccountText"]
              }}
            </div>
          </div>
          <div class="c-container-01">
            {{
              this.currentUser?.companyName?.[0]?.toUpperCase() ||
              resource["subscriptionPageNoAccountText"]?.[0]?.toUpperCase()
            }}
          </div>
        </div>
        <div
          v-if="loading"
          class="c-column-02 d-flex align-items-center justify-content-center"
        >
          <div class="loading-overlay">
            <div id="loading"></div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="companyPackages?.length < 1"
            class="c-column-02 d-flex flex-column align-items-center justify-content-center"
          >
            <p>{{ resource["subscriptionPageNoPackage"] }}</p>
            <br />
            <div>
              <button
                class="bg-purple text-white"
                id="seePlans"
                @click="seePlans"
              >
                {{ resource["navbar.pricingButton"] }}
              </button>
            </div>
          </div>
          <div
            v-else
            v-for="(companyPackage, index) in companyPackages"
            :key="index"
          >
            <hr />
            <div class="c-column-02">
              <div class="c-container-01">
                <div class="c-item-01">
                  {{ resource["subscription.PackageName"] }}
                </div>
                <div class="c-item-02">
                  {{ companyPackage.name }} /
                  {{
                    companyPackage.type
                      ? resource[
                          `pricingTabName.${companyPackage.type?.replace(
                            /\s/g,
                            ""
                          )}`
                        ]
                      : resource[`pricing.free.table`]
                  }}
                </div>
              </div>
              <div class="c-container-01">
                <div class="c-item-01">
                  {{ resource["subscription.PackageCredit"] }}
                </div>
                <div class="c-item-02">
                  {{ companyPackage.rights?.AsyncInterview }}
                </div>
              </div>
              <div class="c-container-01">
                <div class="c-item-01">
                  {{ resource["subscription.UserCount"] }}
                </div>
                <div class="c-item-02">{{ companyPackage.rights?.User }}</div>
              </div>
              <div class="c-container-01" v-if="companyPackage.isSubscription && companyPackage.type === 'monthly'">
                <div class="c-item-01">
                  {{ resource["subscription.Period"] }}
                </div>
                <div class="c-item-02">
                  {{ companyPackage.nextPaymentDate | moment("DD.MM.YYYY") }}
                </div>
              </div>
              <div class="c-container-01">
                <div class="c-item-01">
                  {{ companyPackage.isSubscription ? resource["subscription.EndDate"] : resource["free.EndDate"]}}
                </div>
                <div class="c-item-02">
                  {{ companyPackage.endDate | moment("DD.MM.YYYY") }}
                </div>
              </div>
              <div
                class="d-flex gap-1 align-items-center cancel-area"
                v-if="companyPackage.isSubscription && isTransactionUser"
              >
                <i class="icon-info" />
                <a @click="getStripeCustomerPortalUri" class="cursor-pointer">
                  {{ resource["subscription.cancelSubsText"] }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hrvenueService from '../../services/hrvenue.service';

export default {
  name: 'SubscriptionInformation',
  data() {
    return {
      companyPackages: null,
      isTransactionUser: false,
      loading: true,
    };
  },

  async created() {
    try {
      const result = await hrvenueService.getCompanyPackages();
      if (result.companyPackages) {
        this.companyPackages = result.companyPackages;
        this.isTransactionUser = result.isTransactionUser;
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  },

  computed: {
    getProfileContent() {
      return this.currentUser.companyName[0].toUpperCase();
    },
  },

  methods: {
    async getStripeCustomerPortalUri() {
      this.loading = true;
      if (this.isTransactionUser) {
        const result = await hrvenueService.getStripeCustomerPortalUri();
        if (result) {
          window.open(result, '_blank', 'noreferrer');
        }
      }
      this.loading = false;
    },
    seePlans() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'PricingListView',
        params: { lang },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cancel-area {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #ff8d06;
  margin-top: 16px;

  a {
    text-decoration: underline;
  }

  i {
    font-size: 18px;
  }
}

.my-account {
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  background: #fff;
  padding: 0;
}

hr {
  width: 100%;
  height: 1px;
  background: #e4e4e4;
  margin: 0;
  border: 0;
}

.c-column-01,
.c-column-02 {
  padding: 32px;
}

.c-column-01 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .c-container-01 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    background: #e4e4e4;
    border-radius: 50%;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #353535;
    margin-right: 16px;
  }

  .c-container-02 {
    .c-item-01 {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #858585;
      margin-bottom: 4px;
    }

    .c-item-02 {
      font-family: Roboto;
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
      color: #353535;
    }
  }
}

.c-column-02 {
  .c-container-01 {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .c-item-01 {
      width: 225px;
      color: #353535;
      font-family: Roboto;
      font-size: 14px;
      font-weight: 700;
      line-height: 22px;
    }

    .c-item-02 {
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: #858585;
      display: flex;
      align-items: center;

      .change-pass-btn {
        font-weight: 700;
        color: #ff8d06;
        margin-left: 8px;
      }
    }
  }

  > :last-child {
    margin-bottom: 0;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  border: 0;
  top: 0;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  z-index: 4444;
}

#loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #ff8d06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
